import React, { FC, PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "effector-react";

import { $isLoggedIn } from "src/entities/user/model";

import { Header } from "./header";
import { Footer } from "./footer";

const Layout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = useStore($isLoggedIn);

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/create");
    }

    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isLoggedIn]);

  const hideHeaderAndFooter = location.pathname === "/login";
  const showFooter = location.pathname === "/";

  return (
    <>
      {!hideHeaderAndFooter && <Header />}

      <main>{children}</main>

      {!hideHeaderAndFooter && showFooter && <Footer />}
    </>
  );
};

export default Layout;
